import { Component, ErrorInfo, ReactNode } from "react";
import { constants } from "./constants";

interface Props {
	children?: ReactNode;
}

interface State {
	hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
	};

	public static getDerivedStateFromError(_: Error): State {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		// eslint-disable-next-line no-console
		console.error("Error boundary log:", error, errorInfo);
	}

	public render() {
		if (this.state.hasError) {
			return <h1 style={{ textAlign: "center", marginTop: "25%" }}>{constants.errorBoundaryMessage}</h1>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
